export const services = [
  {
    icon: "ri-clipboard-line",
    title: "本質洞察",
    description: "人材の本質を科学的に見える化する、独自の検査サービスです。",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20illustration%20of%20a%20scientific%20aptitude%20assessment%20system%20for%20human%20resources%2C%20a%20human%20silhouette%20surrounded%20by%20gauge%20meters%20and%20measurement%20charts%2C%20soft%20blue%20and%20teal%20palette%2C%20white%20background%2C%20modern%20vector%20style%20with%20balanced%20composition&width=800&height=600&seq=service-asystem-2026&orientation=landscape",
  },
  {
    icon: "ri-briefcase-line",
    title: "営業支援",
    description: "営業の仕組みづくりから成果向上までを一貫して支援します。",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20illustration%20of%20a%20sales%20support%20workflow%20with%20a%20funnel%2C%20growth%20bar%20charts%20and%20documents%2C%20blue%20and%20warm%20gold%20accent%20colors%2C%20clean%20white%20background%2C%20modern%20business%20vector%20style%20with%20balanced%20composition&width=800&height=600&seq=service-sales-2026&orientation=landscape",
  },
  {
    icon: "ri-line-chart-line",
    title: "事業支援",
    description: "人材活用・組織づくりで事業の成長をトータルに支えます。",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20illustration%20of%20business%20growth%20support%20with%20a%20rising%20line%20graph%2C%20upward%20arrows%20and%20organization%20building%20blocks%2C%20blue%20and%20gold%20accents%2C%20clean%20white%20minimal%20background%2C%20modern%20vector%20editorial%20style%20with%20harmonious%20composition&width=800&height=600&seq=service-business-2026&orientation=landscape",
  },
];

export const painPoints = [
  {
    no: "01",
    icon: "ri-alert-line",
    text: "採用後のミスマッチを減らしたい",
    description:
      "面接だけでは見えない適性や価値観を、科学的な検査データで見える化。入社後のギャップを未然に防ぎ、定着率の向上につなげます。",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20illustration%20of%20two%20puzzle%20pieces%20that%20do%20not%20fit%20together%20representing%20a%20hiring%20mismatch%2C%20one%20blue%20piece%20and%20one%20teal%20piece%20with%20a%20visible%20gap%20between%20them%2C%20soft%20blue%20and%20teal%20color%20palette%2C%20white%20minimal%20background%2C%20modern%20vector%20style%20with%20balanced%20composition&width=1200&height=800&seq=painpoint-mismatch-2026&orientation=landscape",
  },
  {
    no: "02",
    icon: "ri-refresh-line",
    text: "離職率を改善したい",
    description:
      "離職の原因をデータで分析し、早期に兆候をキャッチ。配置や育成の見直しによって、社員が長く活躍できる環境を整えます。",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20illustration%20of%20an%20employee%20walking%20away%20from%20a%20group%20of%20people%20representing%20staff%20turnover%2C%20one%20figure%20leaving%20while%20others%20remain%20together%2C%20soft%20blue%20and%20teal%20color%20palette%2C%20white%20minimal%20background%2C%20modern%20vector%20style%20with%20balanced%20composition&width=1200&height=800&seq=painpoint-turnover-2026&orientation=landscape",
  },
  {
    no: "03",
    icon: "ri-layout-grid-line",
    text: "人材配置を最適化したい",
    description:
      "スキルや適性に基づいて適材適所の配置を実現。VRシミュレーションで組織編成の影響を事前に検討し、最適な人材配置を導きます。",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20illustration%20of%20optimal%20team%20placement%20with%20people%20icons%20arranged%20in%20an%20organizational%20chart%20connected%20by%20arrows%2C%20soft%20blue%20and%20teal%20color%20palette%2C%20white%20minimal%20background%2C%20modern%20vector%20style%20with%20balanced%20composition&width=1200&height=800&seq=painpoint-placement-2026&orientation=landscape",
  },
  {
    no: "04",
    icon: "ri-lightbulb-line",
    text: "新しい営業手法を導入したい",
    description:
      "属人的な営業ノウハウを体系化し、データに基づく営業の仕組みを構築。誰でも再現できる営業手法で、成果の安定化を支援します。",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20illustration%20of%20a%20modern%20data-driven%20sales%20methodology%20with%20a%20sales%20funnel%20and%20a%20rising%20bar%20chart%20under%20a%20magnifying%20glass%2C%20soft%20blue%20and%20teal%20color%20palette%2C%20white%20minimal%20background%2C%20modern%20vector%20style%20with%20balanced%20composition&width=1200&height=800&seq=painpoint-sales-2026&orientation=landscape",
  },
];

export const heroTrustPoints = [
  { icon: "ri-timer-flash-line", label: "解析時間", value: "30秒" },
  { icon: "ri-bar-chart-box-line", label: "客観的データ", value: "100%" },
  { icon: "ri-earth-line", label: "国籍", value: "不問" },
];

export const features = [
  {
    no: "01",
    icon: "ri-layout-grid-line",
    title: "人材データを、ひとつの画面に可視化",
    short: "人材データの一元可視化",
    description:
      "社員のスキル・経歴・資格・評価を一元管理し、人材マップとして可視化。組織の強みや偏りをひと目で把握でき、適材適所の配置検討をスムーズにします。",
    points: [
      "スキルマップで組織の強み・偏りを可視化",
      "経歴・資格・評価をまとめて一元管理",
      "部署をまたいだ人材検索・マッチング",
    ],
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20illustration%20of%20a%20human%20resource%20visualization%20dashboard%20showing%20a%20talent%20map%20with%20employee%20skill%20nodes%20and%20a%203D%20organization%20chart%2C%20soft%20blue%20and%20teal%20color%20palette%2C%20white%20background%2C%20flat%20vector%20style&width=1200&height=800&seq=feature-unified-2026&orientation=landscape&nocache=true",
  },
  {
    no: "02",
    icon: "ri-focus-3-line",
    title: "VR空間で、組織の配置をシミュレーション",
    short: "VR組織シミュレーション",
    description:
      "組織図をVR空間に3Dで再現し、チーム編成の変更が組織に与える影響をシミュレーション。実際に動かす前に、最適な配置を検討できます。",
    points: [
      "VR空間でチーム編成をシミュレーション",
      "3D組織図で人材の配置・距離感を把握",
      "複数の変更案を並べて比較検討",
    ],
    image:
      "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20of%20a%20VR%20headset%20and%20a%203D%20organization%20chart%20floating%20in%20virtual%20space%20for%20team%20placement%20simulation%2C%20blue%20and%20white%20color%20palette%2C%20clean%20modern%20vector%20style&width=1200&height=800&seq=feature-media-link-2026&orientation=landscape&nocache=true",
  },
  {
    no: "03",
    icon: "ri-scan-line",
    title: "ARで、現場のスキルをその場で見える化",
    short: "AR現場スキル可視化",
    description:
      "スマートフォンやARグラスをかざすだけで、現場のスキル状況や作業手順を重ねて表示。属人化しがちな現場のノウハウを、誰でも確認できる形にします。",
    points: [
      "現場作業をARでガイド・サポート",
      "スキル状況をその場で確認",
      "教育・OJTの効率化と標準化",
    ],
    image:
      "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20of%20a%20smartphone%20scanning%20a%20workplace%20scene%20with%20augmented%20reality%20skill%20data%20panels%20overlaid%2C%20blue%20accent%20colors%2C%20white%20minimal%20background%2C%20modern%20vector%20design&width=1200&height=800&seq=feature-scheduling-2026&orientation=landscape&nocache=true",
  },
  {
    no: "04",
    icon: "ri-line-chart-line",
    title: "データ分析・レポートで、意思決定を支える",
    short: "データ分析・レポート",
    description:
      "人材データを多角的に分析し、配置・育成・採用の意思決定をデータで支援。組織の課題を可視化し、定期レポートとして自動で出力します。",
    points: [
      "組織・人材を分析するダッシュボード",
      "定例レポートをワンクリックで自動出力",
      "経営層向けのわかりやすい可視化",
    ],
    image:
      "https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20of%20a%20workforce%20analytics%20dashboard%20with%20charts%2C%20skill%20distribution%20graphs%20and%20report%20documents%2C%20blue%20and%20gold%20accent%20colors%2C%20clean%20white%20background%2C%20modern%20vector%20design&width=1200&height=800&seq=feature-analytics-2026&orientation=landscape&nocache=true",
  },
];

export const testimonials = [
  {
    company: "株式会社クラフティ",
    name: "人事部 課長",
    person: "田村 亮介 様",
    quote:
      "社員のスキルが人材マップで一目でわかるようになり、配置の検討がとてもラクになりました。操作もかんたんで、現場がすぐに使いこなしています。",
    image:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20japanese%20businessman%20in%20his%2040s%20wearing%20a%20navy%20suit%2C%20clean%20neutral%20studio%20background%2C%20soft%20natural%20lighting%2C%20corporate%20editorial%20photography&width=400&height=400&seq=person-tamura-2026&orientation=squarish",
  },
  {
    company: "株式会社オルブ",
    name: "人事総務部 マネージャー",
    person: "小泉 由美 様",
    quote:
      "VRでの配置シミュレーションは、これまで話し合いだけでは見えなかった影響を可視化してくれます。料金も明朗で、導入のハードルが低かったです。",
    image:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20japanese%20businesswoman%20in%20her%2030s%20wearing%20a%20light%20grey%20blazer%2C%20clean%20neutral%20studio%20background%2C%20soft%20natural%20lighting%2C%20corporate%20editorial%20photography&width=400&height=400&seq=person-koizumi-2026&orientation=squarish",
  },
  {
    company: "東都精密工業株式会社",
    name: "生産管理部 リーダー",
    person: "村上 健太 様",
    quote:
      "ARで現場のスキル状況をその場で確認できるのが画期的です。分析レポートのおかげで、育成計画をデータで説明できるようになりました。",
    image:
      "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20japanese%20businessman%20in%20his%2050s%20wearing%20a%20charcoal%20suit%20with%20a%20tie%2C%20clean%20neutral%20studio%20background%2C%20soft%20natural%20lighting%2C%20corporate%20editorial%20photography&width=400&height=400&seq=person-murakami-2026&orientation=squarish",
  },
];

export const relatedServices = [
  {
    icon: "ri-clipboard-line",
    label: "適正検査",
    title: "適性検査システム\nA-SYSTEM",
    description:
      "性格・価値観・思考傾向を科学的に分析し、採用や配置のミスマッチを防ぐ適性検査サービスです。",
    href: "https://a-system.tech/?utm_source=namba-inc&utm_medium=referral&utm_campaign=aptitude-test&from=namba-inc",
    cta: "詳しく見る",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20vector%20illustration%20of%20a%20personality%20and%20aptitude%20assessment%2C%20a%20human%20profile%20silhouette%20with%20a%20checklist%20and%20measurement%20gauge%20charts%2C%20soft%20teal%20and%20navy%20palette%2C%20pure%20white%20background%2C%20modern%20editorial%20style%20with%20balanced%20composition&width=800&height=500&seq=related-aptitude-2026&orientation=landscape",
  },
  {
    icon: "ri-heart-pulse-line",
    label: "ストレスチェック",
    title: "ストレスチェック\nココベルケア",
    description:
      "従業員のストレス状態を手軽にチェックし、メンタル不調の早期発見と職場環境の改善を支援します。",
    href: "https://cocovel-care.jp/?utm_source=namba-inc&utm_medium=referral&utm_campaign=stress-check&from=namba-inc",
    cta: "詳しく見る",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20vector%20illustration%20of%20a%20workplace%20stress%20check%20survey%2C%20a%20clipboard%20questionnaire%20with%20a%20heart%20pulse%20line%20and%20calm%20office%20icons%2C%20soft%20teal%20and%20mint%20palette%2C%20pure%20white%20background%2C%20modern%20editorial%20style%20with%20balanced%20composition&width=800&height=500&seq=related-stress-2026&orientation=landscape",
  },
  {
    icon: "ri-mental-health-line",
    label: "メンタルケア",
    title: "メンタルヘルスケア支援",
    description:
      "専門家によるカウンセリングと組織的なケアで、社員が安心して働ける職場づくりをサポートします。",
    href: "",
    cta: "",
    image:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20flat%20vector%20illustration%20of%20mental%20health%20care%20support%2C%20a%20counselor%20and%20employee%20in%20a%20calm%20consultation%20scene%20with%20soft%20plant%20and%20speech%20bubble%20icons%2C%20soft%20teal%20and%20warm%20sand%20palette%2C%20pure%20white%20background%2C%20modern%20editorial%20style%20with%20balanced%20composition&width=800&height=500&seq=related-mental-2026&orientation=landscape",
  },
  {
    icon: "ri-megaphone-line",
    label: "プロモーション",
    title: "共創型プロモーション\nPassionMovers",
    description:
      "人とマーケットを動かすプロモーション支援サービス。個人事業主でも大規模なビジネス商材を扱える共創型プラットフォームです。",
    href: "https://www.passion-movers.co.jp",
    cta: "詳しく見る",
    image:
      "https://static.wixstatic.com/media/975f36_f435b211a63a42d892da555cf9ca9102%7Emv2.png/v1/fit/w_1200,h_638,al_c/975f36_f435b211a63a42d892da555cf9ca9102%7Emv2.png",
  },
];

export const navGroups = [
  {
    title: "関連サービス",
    items: [
      {
        label: "適正検査",
        href: "https://a-system.tech/?utm_source=namba-inc&utm_medium=referral&utm_campaign=aptitude-test&from=namba-inc",
        icon: "ri-clipboard-line",
        description: "性格・価値観・思考傾向を科学的に分析し、採用や配置のミスマッチを防ぎます。",
      },
      {
        label: "ストレスチェック",
        href: "https://cocovel-care.jp/?utm_source=namba-inc&utm_medium=referral&utm_campaign=stress-check&from=namba-inc",
        icon: "ri-heart-pulse-line",
        description: "従業員のストレス状態を手軽にチェックし、メンタル不調の早期発見を支援します。",
      },
    ],
  },
  {
    title: "その他",
    items: [
      {
        label: "PassionMovers",
        href: "https://www.passion-movers.co.jp",
        icon: "ri-megaphone-line",
        description: "人とマーケットを動かす、プロモーション支援サービスです。",
      },
      {
        label: "私たちについて",
        href: "#about",
        icon: "ri-information-line",
        description: "株式会社ナンバの想いと会社概要をご紹介します。",
      },
    ],
  },
];

export const partners = [
  {
    name: "ワイルドマート合同会社",
    logo: "https://storage.helloreaddy.io/project_files/79fca178-4792-4aab-8388-df2f7bf7f75f/39528574-eb89-4be7-8c49-8ede82c39d9f_compressed_-2.webp",
  },
  {
    name: "合同会社ココベル",
    logo: "https://storage.helloreaddy.io/project_files/79fca178-4792-4aab-8388-df2f7bf7f75f/15395ccf-1ad7-46f4-8cd6-83513fe181c4_compressed_2.webp",
  },
  {
    name: "株式会社パッションムーバーズ",
    logo: "https://storage.helloreaddy.io/project_files/79fca178-4792-4aab-8388-df2f7bf7f75f/3b190fb5-03b6-47a8-a1be-00ddb1c3e18b_compressed_-2026-10-14-10.54.39.webp",
  },
];